import apiClient from "@toothfairy/shared-api/apiClient";
import secureRequest from "@toothfairy/shared-api/secureAPI";
import envConfig from "../../../envConfig";
import AppAuth from "@toothfairy/shared-ui/AppAuthScreen";

// This is the way it is as we will not replicate the agents across the different regions at this stage
const fetchHireableAgents = async () => {
  const url = `${
    envConfig.REACT_APP_ENV == "dev"
      ? "https://api.toothfairylab.link"
      : "https://api.toothfairyai.com"
  }/global_utils/fetch_hireable_agents`;

  const payload = await AppAuth.getCurrentSession();
  return secureRequest(
    apiClient.apiClient,
    "GET",
    url,
    null,
    null,
    true,
    null,
    payload,
  );
};

/**
 * Spawn a new AI agent using the AI-powered agent generation endpoint
 * @param {string} workspaceid - Workspace ID
 * @param {string} apiKey - Workspace API key for x-api-key header
 * @param {string} instruction - Natural language description of what the agent should do
 * @param {Array} [allowed_topics] - Optional array of knowledge base topics for RAG
 * @returns {Promise<Object>} Generated agent configuration
 */
const spawnAgent = async (
  workspaceid,
  apiKey,
  instruction,
  allowed_topics = [],
) => {
  const baseUrl = envConfig.REACT_APP_AIS_ENDPOINT;
  const url = `${baseUrl}/spawn-agent`;

  const requestBody = {
    workspaceid,
    instruction,
    ...(allowed_topics && allowed_topics.length > 0 && { allowed_topics }),
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": apiKey,
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Request failed with status ${response.status}`);
  }

  return response.json();
};

export default { fetchHireableAgents, spawnAgent };
